import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./rootContainer.html";
import { selectUrl, WireStore } from '@oneappexchange/lwc-wired';
import { IN_MAINTENANCE, PRE_AUTH_REDIRECT_URL_LS_KEY } from '~/config';
import { selectShared, WireI18n } from '~/modules/stores/i18nStore';
import { publisherStore, selectPublisher } from '~/modules/stores/publisher/publisherStore';
import { ERROR_ROUTE, LOGGED_OUT_ROUTE, MAINTENANCE_ROUTE, navigate, WireRouter } from '~/modules/stores/routerStore';
import { selectUserData, userStore } from '~/modules/stores/userStore';
import { authFailedError, badPublisherError } from '~/modules/utilities/errorUtilities';
class RootContainer extends LightningElement {
  constructor(...args) {
    super(...args);
    this.isAuthenticated = false;
    this.hasPublisher = false;
    this.isErrorPage = false;
    this.isLoggedOutPage = false;
    this.isMaintenancePage = false;
    this.userData = void 0;
    this.sharedLabels = void 0;
  }
  userDataCallback(userData) {
    this.userData = userData;
    this.isAuthenticated = userData != null;
  }
  publisherCallback(publisher) {
    this.hasPublisher = publisher != null;
  }
  async urlCallback(url) {
    this.isErrorPage = url.indexOf(ERROR_ROUTE) !== -1;
    this.isLoggedOutPage = url.indexOf(LOGGED_OUT_ROUTE) !== -1;
    this.isMaintenancePage = url.indexOf(MAINTENANCE_ROUTE) !== -1 || IN_MAINTENANCE;
    if (this.needsAuthentication && !this.isAuthenticated) {
      try {
        const userData = await userStore.authenticate();
        if (userData) {
          this.userData = userData;
          const publisher = await publisherStore.fetchPublisher();
          if (!publisher) {
            badPublisherError();
            return;
          }
          const redirectUrl = window.localStorage.getItem(PRE_AUTH_REDIRECT_URL_LS_KEY);
          if (redirectUrl) {
            window.localStorage.removeItem(PRE_AUTH_REDIRECT_URL_LS_KEY);
            navigate(redirectUrl);
          }
        }
      } catch (error) {
        authFailedError(error);
      }
    }
  }
  get isLoggedIn() {
    return this.isAuthenticated && this.hasPublisher;
  }
  get needsAuthentication() {
    return !this.isErrorPage && !this.isLoggedOutPage && !this.isMaintenancePage;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(RootContainer, {
  wire: {
    sharedLabels: {
      adapter: WireI18n,
      dynamic: [],
      config: function ($cmp) {
        return {
          selector: selectShared
        };
      }
    },
    userDataCallback: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: userStore,
          selector: selectUserData
        };
      }
    },
    publisherCallback: {
      adapter: WireStore,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          store: publisherStore,
          selector: selectPublisher
        };
      }
    },
    urlCallback: {
      adapter: WireRouter,
      dynamic: [],
      method: 1,
      config: function ($cmp) {
        return {
          selector: selectUrl
        };
      }
    }
  },
  fields: ["isAuthenticated", "hasPublisher", "isErrorPage", "isLoggedOutPage", "isMaintenancePage", "userData"]
});
const __lwc_component_class_internal = _registerComponent(RootContainer, {
  tmpl: _tmpl,
  sel: "page-root-container",
  apiVersion: 62
});
export default __lwc_component_class_internal;